export const NUMBER_FORMAT_DE = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  
  export function toDate(value: any): Date | null {
    if (!value) return null;
    if (value instanceof Date) return value;
    if (typeof value?.toDate === 'function') return value.toDate();     // Firestore SDK Timestamp
    if (value?.seconds)  return new Date(value.seconds  * 1000);       // plain { seconds }
    if (value?._seconds) return new Date(value._seconds * 1000);       // plain { _seconds } (serialised)
    if (typeof value === 'string' || typeof value === 'number') return new Date(value);
    return null;
  }
  
  
  export function toNumber(value: unknown): number | null {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value === 'string') {
      const normalized = value.replace(',', '.').trim();
      if (!normalized) return null;
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : null;
    }
    return null;
  }
  
  /**
   * Format a length value (metres) as a human-readable German-locale string.
   * < 1 000 m → "X m", ≥ 1 000 m → "X,XX km"
   */
  export function formatLength(
    lengthValue: unknown,
    fmt: Intl.NumberFormat = NUMBER_FORMAT_DE,
  ): string {
    const length = toNumber(lengthValue);
    if (length == null) return '';
    if (Math.abs(length) < 1_000) return `${fmt.format(length)} m`;
    return `${fmt.format(length / 1_000)} km`;
  }
  
  /**
   * Format an area value (m²) as a human-readable German-locale string.
   * Always in hectares: "X,XX ha"
   */
  export function formatArea(
    areaValue: unknown,
    fmt: Intl.NumberFormat = NUMBER_FORMAT_DE,
  ): string {
    const area = toNumber(areaValue);
    if (area == null) return '';
    return `${fmt.format(area / 10_000)} ha`;
  }
  
  /** Convert a camelCase field name to a space-separated title-case label. */
  export function prettyName(field: string): string {
    return field
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, s => s.toUpperCase());
  }
  